import React from "react";
import SelectVariants from "../Select";

import { getYears } from "../../data";
import { useYear, useYearUpdate } from "../../contexts/YearContext";

const SelectYear = ({ withLabel = true, small = false }) => {
  const year = useYear()
  const setYear = useYearUpdate()

  const years = getYears()

  const defaultValue = 2020;
  const name = "YEAR";
  const options = years.map((y) => {
    return {
        value: y,
        label: y.toString()
    }
  })

  return (
    <SelectVariants
      withLabel={withLabel}
      small={small}
      name={name}
      field={year}
      setField={setYear}
      options={options}
      defaultValue={defaultValue}
    />
  );
};

export default SelectYear;
